'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _utils = require('./../utils');

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListComponent = function (_AbstractReactCompone) {
    (0, _inherits3.default)(ListComponent, _AbstractReactCompone);

    function ListComponent() {
        (0, _classCallCheck3.default)(this, ListComponent);
        return (0, _possibleConstructorReturn3.default)(this, (ListComponent.__proto__ || (0, _getPrototypeOf2.default)(ListComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(ListComponent, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                store = _props.store,
                renderItem = _props.renderItem,
                renderContainer = _props.renderContainer;


            return renderContainer(store.rows.map(renderItem));
        }
    }]);
    return ListComponent;
}(_AbstractReactComponent2.default);

ListComponent.defaultProps = {
    renderContainer: function renderContainer(child) {
        return _react2.default.createElement(
            'div',
            null,
            child
        );
    }
};
ListComponent.PropTypes = {
    area: _react2.default.PropTypes.string.isRequired,
    renderItem: _react2.default.PropTypes.func.isRequired,
    renderContainer: _react2.default.PropTypes.func
};
exports.default = (0, _reactRedux.connect)(function (state, props) {
    return { store: (0, _utils.storeFromArea)(state, props.area) };
})(ListComponent);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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